import { M3_BRAND, M3_COLORS } from "./m3Palette";

const lightM3 = M3_COLORS.light;
const darkM3 = M3_COLORS.dark;

// MUI status palette built from the M3 status roles.
const statusPalette = (m3, role) => ({
  light: m3[`${role}Container`],
  main: m3[role],
  dark: m3[`on${role[0].toUpperCase()}${role.slice(1)}Container`],
  contrastText: m3[`on${role[0].toUpperCase()}${role.slice(1)}`],
});

const statusPalettes = (m3) => ({
  success: statusPalette(m3, "success"),
  info: statusPalette(m3, "info"),
  warning: statusPalette(m3, "warning"),
  error: statusPalette(m3, "error"),
});

const basePalette = {
  arivuLogocolor1: M3_BRAND.primary,
  arivuLogocolor2: M3_BRAND.neutral,
  sidebarBackground: "#061d15",
  primary: {
    main: M3_BRAND.primary,
  },
  secondary: {
    main: "#b45309",
  },
  sidebar_divider: "rgba(255, 255, 255, 0.12)",
};

const lightPalette = {
  mode: "light",
  ...basePalette,
  ...statusPalettes(lightM3),
  text: {
    main: "#000000",
    main_hover: "grey",
    primary: "#000000",
    secondary: "#4b4b4b",
    navigation: "#166534",
    navigation_selected: "#18183e",
    button: "#ffffff",
    title: lightM3.onSurface,
    subtitle: lightM3.onSurfaceVariant,
    tableTitle: lightM3.onSurface,
    table_title: lightM3.onSurface,
    table_sub_title: lightM3.onSurfaceVariant,
    grid_header: lightM3.onSurfaceVariant,
    sidebar_header_level_1: "#374151",
    sidebar_header_level_2: "#659d33",
    secondary_tab: "#659d33",
    graphText: "#333333",
    textbox_label: "#4b5563",
    piechart_inner_title: "#649837",
  },
  border: {
    main: lightM3.outlineVariant,
    table: lightM3.outlineVariant,
    indicator: "#15a440",
  },
  background: {
    default: lightM3.surfaceContainerLowest,
    page: lightM3.surfaceContainerLow,
    pageBackground: lightM3.surface,
    paper: lightM3.surfaceContainerLowest,
    card: lightM3.surfaceContainerLowest,
    navigation: "#D0EDDB",
    button: "rgba(22, 163, 74, 0.2)",
    button_hover: "rgba(22, 163, 74, 0.9)",
    button_disabled: "#b0bec5",
    tabTitle: "#f1f1f1",
    sidebar: "#061d15", // Dark Sidebar as a standard brand element
  },
  // Card colors for light mode
  cards: {
    totalCarbon: { bg: "#f0fdf4", border: "#bbf7d0", text: "#166535" },
    material: { bg: "#eff6ff", border: "#bfdbfe", text: "#1e40af" },
    transport: { bg: "#fef2f2", border: "#fecaca", text: "#991b1b" },
    energy: { bg: "#fff7ed", border: "#fed7aa", text: "#9a3412" },
    stageA1A3: { bg: "#f0fdf4", border: "#bbf7d0" },
    stageA4A5: { bg: "#eff6ff", border: "#bfdbfe" },
    stageB: { bg: "#fef2f2", border: "#fecaca" },
    stageC: { bg: "#fff7ed", border: "#fed7aa" },
    stageD: { bg: "#f3e8ff", border: "#d8b4fe" },
    mciAvg: { bg: "#f0fdf4", border: "#86efac" },
  },
};

const darkPalette = {
  mode: "dark",
  ...basePalette,
  ...statusPalettes(darkM3),
  text: {
    main: "#e8e8e8",
    primary: "#e8e8e8",
    secondary: "#e0e0e0",
    navigation: "#4ade80",
    navigation_selected: "#86efac",
    button: "#ffffff",
    title: darkM3.onSurface,
    subtitle: darkM3.onSurfaceVariant,
    tableTitle: darkM3.onSurface,
    table_title: darkM3.onSurface,
    table_sub_title: darkM3.onSurfaceVariant,
    grid_header: darkM3.onSurfaceVariant,
    sidebar_header_level_1: "#e5e7eb",
    sidebar_header_level_2: "#86efac",
    secondary_tab: "#86efac",
    graphText: "#ffffff",
    textbox_label: "#cbd5e1",
    piechart_inner_title: "#cbd5e1",
  },

  border: {
    main: darkM3.outlineVariant,
    table: darkM3.outlineVariant,
  },
  background: {
    default: darkM3.surface,
    page: darkM3.surfaceContainerLowest,
    pageBackground: darkM3.surface,
    paper: darkM3.surfaceContainerLow,
    card: darkM3.surfaceContainer,
    navigation: "#1E4F30",
    // navigation: "red",
    button: "rgba(74, 222, 128, 0.2)",
    button_hover: "rgba(74, 222, 128, 0.4)",
    button_disabled: "#52525b",
    tabTitle: "#27272a",
    sidebar: "#061d15",
  },
  // Card colors for dark mode (Very Vibrant, Solid backgrounds)
  cards: {
    totalCarbon: { bg: "#659d33", border: "#4ade80", text: "#ffffff" },
    material: { bg: "#2563eb", border: "#60a5fa", text: "#ffffff" },
    transport: { bg: "#dc2626", border: "#f87171", text: "#ffffff" },
    energy: { bg: "#ea580c", border: "#fbbf24", text: "#ffffff" },
    stageA1A3: { bg: "#659d33", border: "#4ade80" },
    stageA4A5: { bg: "#2563eb", border: "#60a5fa" },
    stageB: { bg: "#dc2626", border: "#f87171" },
    stageC: { bg: "#ea580c", border: "#fbbf24" },
    stageD: { bg: "#8b5cf6", border: "#a78bfa" },
    mciAvg: { bg: "#166534", border: "#4ade80" },
  },
};

export const getPalette = (mode) => (mode === "dark" ? darkPalette : lightPalette);
